module.exports = __webpack_public_path__ + "05_short_black.7c491001.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/05_short_black.png
// module id = znAT
// module chunks = 0